import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('wrap'));

const res = await fetch('https://api.ipify.org?format=json');
const data = await res.json();

const host = window.location.host;
console.log(data.ip)
if (host.startsWith('twpal') && !data.ip.startsWith('123.141.45')) {
    window.location.href = 'https://wpal.philippineair.co.kr';
}

root.render(<App />);
